import { RAW as RAW9 } from "./9.js";
import { RAW as RAW10 } from "./10.js";
import { RAW as RAW11 } from "./11.js";
import { RAW as RAW12 } from "./12.js";

/** @param {unknown} grade Class year 9–12; anything else defaults to 10. */
export function getRawForGrade(grade) {
  const g = Number(grade);
  if (g === 9) return RAW9;
  if (g === 11) return RAW11;
  if (g === 12) return RAW12;
  return RAW10;
}

export { RAW9, RAW10, RAW11, RAW12 };
